function isValidLiskAddress(address, currency, networkType) {
    const regex = /^[0-9]{1,20}L$/g; // Must be numbers only for the first 1 - 20 charactors with a capital L at the end
    return address.search(regex) !== -1;
}

export default {
    isValidAddress(address, currency, networkType) {
        return isValidLiskAddress(address, currency, networkType);
    },
};
